/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_LabelInputs */

const en_mk_faq_label = /** @type {(inputs: Mk_Faq_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const id_mk_faq_label = /** @type {(inputs: Mk_Faq_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya jawab`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Mk_Faq_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_label = /** @type {((inputs?: Mk_Faq_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_label(inputs)
	return en_mk_faq_label(inputs)
});